module.exports = __webpack_public_path__ + "img/35.7567ac91.jpg";